import type { W_Equipment_FindAllForCompanyList_VM } from 'ab-api/web/equipment/findAllForCompanyList';

import { formatDate } from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

const EMPTY_SKILL = {
	id: null,
	name: '',
	color: null,
};

const CSV_REQUIRED_KEYS = [
	'ID',
	'color',
	'type',
	'group',
	'category',
	'subcategory',
	'homeOffice',
	'lastUpdateAt',
	'lastUpdateBy',
	'plateNumber',
	'plateType',
	'registrationState',
	'registrationExpiration',
	'inspectionStickerExpiration',
	'vinNumber',
	'gvw',
	'year',
	'make',
	'model',
	'driversAlertId',
	'tollPassId',
	'hutNumber',
	'showOnScheduleBoard',
	'equipmentStatus',
	'skill.0.name',
	'skill.0.color',
];

export const toCSVData = (viewModel: W_Equipment_FindAllForCompanyList_VM): string[][] => {
	const maxNumberOfSkills = 1;	// if skills are able to be shown on export, the first group of columns should always be visible

	const rows: string[][] = viewModel.list.map((_item: W_Equipment_FindAllForCompanyList_VM['list'][number]) => {
		const _row: string[] = [
			`${_item.code} ${_item.specification}`,
			_item.color ?? '',
			_item.type,
			_item.groupName,
			_item.categoryName,
			_item.subcategoryName,
			_item.locationNickname,
			formatDate(_item.updatedAt, TimeFormat.FULL_DATE),	// NOTE: function must be called from FE to use the user's timezone
			_item.updatedBy.fullName,
			_item.plateNumber ?? '',
			_item.plateType ?? '',
			_item.registrationState ?? '',
			_item.registrationExpiration ? formatDate(_item.registrationExpiration, TimeFormat.DATE_ONLY_SLASHES, TimeFormat.DB_DATE_ONLY) : '',
			_item.inspectionStickerExpiration ? formatDate(_item.inspectionStickerExpiration, TimeFormat.DATE_ONLY_SLASHES, TimeFormat.DB_DATE_ONLY) : '',
			_item.vinNumber ?? '',
			_item.gvw ? `${_item.gvw}` : '',
			_item.year ? `${_item.year}` : '',
			_item.make ?? '',
			_item.model ?? '',
			_item.driversAlertId ?? '',
			_item.tollPassId ?? '',
			_item.hutNumber ?? '',
			_item.showOnScheduleBoard ? 'Yes' : 'No',
			_item?.equipmentStatus?.name ?? '',
		];

		for (let _index = 0; _index < maxNumberOfSkills; _index++) {
			const _skill = _item.skills[_index] || EMPTY_SKILL;
			_row.push(_skill.name, _skill.color);
		}

		return _row;
	});

	return [CSV_REQUIRED_KEYS, ...rows];
};
